<template>
  <!--头部搜索栏-->
  <header>
    <div class="search-text">
      <input
        ref="search"
        v-model="inputText"
        type="search"
        :placeholder="'正在热搜：' + keyword"
        class="search_input"
        @keyup.enter="toSearch"
      />
      <!--<ul class="asso-match" v-if="isShow">-->
      <!--<li @click="quickSel" v-for="(item,index) in message" :key="index">-->
      <!--{{item}} <i class="shortcut"></i>-->
      <!--</li>-->
      <!--</ul>-->
    </div>
    <span
      v-ptt="['btn', 'go-search', '点击搜索按钮触发']"
      class="search_button"
      @click="toSearch"
    >搜索</span>
    <span
      class="goback"
      @click="goBack"
    ><i /></span>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isShow: true,
      inputText: '',
      message: ['沙漠', '沙漠绿洲', '沙漠绿洲用地', '沙漠皮卡多', '沙漠新山城'],
    };
  },
  computed: {
    keyword() {
      return this.$store.state.hotKeyWord.title || '';
    },
    _isFocus() {
      return this.$store.state.isFocus;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(currentRoute, preRoute) {
        const key = currentRoute.params.keyword;
        if (key) {
          this.inputText = key;
        }
        this.$nextTick(() => {
          // 当前路由是search的，添加class，保持搜索状态
          const currentIsSearch = currentRoute.name === 'searchnew' || currentRoute.name === 'searchnew-result';
          if (currentIsSearch) {
            document.querySelector('#g-layer').classList.add('search');
            return;
          }

          // 存在上一个路由，且上一个路由是从search出来的，移除class，退出搜索状态
          const preIsSearch = preRoute && (preRoute.name === 'searchnew' || preRoute.name === 'searchnew-result');
          // 当前路由是详情页
          const currentIsDetail = currentRoute.name === 'news-detail' || currentRoute.name === 'video-detail';

          // 从搜索页来，且去到的不是详情页（搜索页可以到的页面，且没有#g-play元素）
          if (preIsSearch && !currentIsDetail) {
            document.querySelector('#g-layer').classList.remove('search');
          }
        });
      },
    },
  },
  activated() {
    if (this._isFocus) {
      this.isFocus();
    } else {
      this.isBlur();
    }
  },
  mounted() {
    this.isFocus();
    this.$store.dispatch('getHotSearchKeyWord');
  },
  methods: {
    isFocus() {
      this.$nextTick(() => {
        this.$refs.search.focus();
      });
    },
    isBlur() {
      this.$nextTick(() => {
        this.$refs.search.blur();
      });
    },
    goBack() {
      const { form, keyword } = this.$route.params;
      if (keyword) {
        this.$router.replace({
          name: 'searchnew',
          params: {
            form,
          },
        });
        this.$store.dispatch('updateIsFocus', false);
      } else {
        this.$router.replace({ name: form });
        this.$store.dispatch('updateIsFocus', true);
      }
    },
    toSearch() {
      this.$store.dispatch('updateIsFocus', false);
      this.isBlur();
      let keyword = '';
      const type = Object.prototype.toString.call(this.inputText);
      if (type === '[object String]' && this.inputText.trim() === '') {
        this.inputText = this.keyword;
      }
      keyword = this.inputText.trim();
      this.$emit('search', keyword);
      this.$store.dispatch('updateSearchHistory', keyword);

      // 如果这次搜索内容和params一样，则不重复调起跳转
      if (this.$route.params.keyword === keyword) return;
      this.$router.replace({
        name: 'searchnew-result',
        params: { keyword },
      });
    },
  },
};
</script>

<style scoped></style>
